import { render, staticRenderFns } from "./ReviewsCategoriesColorTriadTable.vue?vue&type=template&id=7ff52fee&"
import script from "./ReviewsCategoriesColorTriadTable.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesColorTriadTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports